<template>
	<vueCustomScrollbar id="preview_book" class="preview-book text-center" @ps-scroll-y="handleScroll" ><!-- @scroll.passive="handleScroll" -->
		<img v-for="(item, index) of images" :id="`item_${index + 1}`" :key="index" class="item bg-color-light text-center item-book" :src="item" :alt="fileName">
	</vueCustomScrollbar>
</template>

<script>
	import vueCustomScrollbar from 'vue-custom-scrollbar'
	import { APP_CONFIG } from '@/utils/constants';

	export default {
		name: 'PreviewBookImg',
		components: {
			vueCustomScrollbar
		},
		props: {
      totalPage: Number,
      fileName: String,
      zoomData: Number,
      fullPath: Boolean,
      isLocal: Boolean
    },
		data () {
			return {
        page: 0,
        images: [],
        bookImgCdnUrl: APP_CONFIG.bookImgCdnUrl,
        scrollPosition: 0,
        lastPageOffsetTop: 0,
				imgWidthDefault: 0,
				imgHeightDefault: 0
			}
		},
		watch: {
			'zoomData': 'onChangeZoom'
		},
		mounted() {
			this.getBooksImages();
			this.setSizeDefault();
		},
		destroyed() {
			this.images.length = 0;
		},
		methods: {
			setSizeDefault() {
				setTimeout(() => {
					let elm = document.getElementsByClassName('item-book')[0];
          if (elm) {
  					this.imgWidthDefault = elm.clientWidth;
  					this.imgHeightDefault = elm.clientHeight;
          }
				}, 1000);
			},

			getBooksImages() {
				let self = this;
				let loadingLength = 3;
				for(let i = 0; i < loadingLength; i++) {
					self.page += 1;
          let linkPage = self.fullPath ? `${self.fileName}-${self.page}.jpg` : `${self.bookImgCdnUrl}${self.fileName}-${self.page}.jpg`
          if (self.isLocal) {
          //   console.log('File local');
            linkPage = self.getDocsLocal(linkPage)
          }
					self.page <= self.totalPage && self.images.push(linkPage)
				}
			},

      getDocsLocal (link) {
        return require(`@/assets/docs/${link}`)
      },

			handleScroll (event) {
				let currentScrollPosition = event.srcElement.scrollTop;
        if (currentScrollPosition > this.scrollPosition && this.page < this.totalPage) {
        	this.lastPageOffsetTop = document.getElementById(`item_${this.page}`).offsetTop;
        	currentScrollPosition + 50 >= this.lastPageOffsetTop && this.getBooksImages();
        	this.scrollPosition = currentScrollPosition;
        }
			},

			onChangeZoom() {
				let self = this;
				let allPage = document.querySelectorAll('.item-book');
				let lengthAllPage = allPage.length;
				let stringZoom = self.zoomData.toFixed(1).toString();
				let splitZoomValue = 0;
				let scaleMul = window.innerWidth > 991 ? 100 : 50;
				if( self.zoomData > 1) {
					splitZoomValue = stringZoom.split('.');
				}
				for (let i = 0; i < lengthAllPage; i++) {
			    allPage[i].style.width = self.imgWidthDefault*self.zoomData + 'px';
			    allPage[i].style.height = self.imgHeightDefault*self.zoomData + 'px';
			    allPage[i].style.maxWidth = 'inherit';
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	#preview_book {
		max-height: 85vh;
		overflow-y: auto;

		.item {
			display: block;
			margin: 0 auto 30px auto;
			// max-width: inherit;
		}
	}
</style>